import { PeriodicType } from './enumerations/periodicType';

// Mirrors DriverScoreDTO / DriverVehicleRef / DriverScoreDetailDTO / VehicleWindowDetail.
export type KpiGroup = 'ONE' | 'TWO' | 'THREE' | 'FOUR' | 'FIVE' | 'SIX';

export type DriverKpiScore = {
  vehicleId: number;
  kpiMainId: number;
  kpiHardwareName: string | null;
  score: number;
  group: KpiGroup;
  lowEvents: number | null;
  mediumEvents: number | null;
  highEvents: number | null;
  uniqueEvents: number | null;
  // Human-readable KPI name (e.g. "sharp_braking"), resolved server-side from kpiMainId.
  kpiName: string | null;
};

export type DriverVehicleRef = {
  truckImplementId: number;
  licensePlate: string | null;
  vehicleModelName: string | null;
};

export type DriverScore = {
  userId: number | null;
  userName: string | null;
  identificationCode: string | null;
  companyId: number | null;
  companyName: string | null;
  registry: string | null;
  generalScore: number | null;
  scoresByKpi: DriverKpiScore[];
  assignedVehicles: DriverVehicleRef[];
  period: PeriodicType | null;
};

export type DriverVehicleWindowDetail = {
  truckImplementId: number;
  licensePlate: string | null;
  fromDay: string | null; // inclusive
  toDay: string | null; // exclusive
  generalScore: number | null;
  scoresByKpi: DriverKpiScore[];
  // Same statistical indicators the control tower shows next to the score; null when the vehicle has no data.
  odometer?: number | null;
  fuelConsumption?: number | null;
  kmPerLiter?: number | null;
};

export type DriverScoreDetail = DriverScore & {
  vehicles: DriverVehicleWindowDetail[];
};

export const defaultValue: Readonly<DriverScore> = {
  userId: null,
  userName: null,
  identificationCode: null,
  companyId: null,
  companyName: null,
  registry: null,
  generalScore: null,
  scoresByKpi: [],
  assignedVehicles: [],
  period: null,
};
